// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useCallback, useEffect, useRef } from 'react';
function useIsMounted() {
    var isMountedRef = useRef(true);
    useEffect(function () { return function () {
        isMountedRef.current = false;
    }; }, []);
    return function () { return isMountedRef.current; };
}
/**
 * Debounce hook based on https://stackoverflow.com/a/62017005
 * @param cb Callback function
 * @param delay Debounce delay
 * @param options lodash debounce options
 * @returns
 */
export default function useDebounce(cb, delay, options) {
    var inputsRef = useRef({ cb: cb, delay: delay });
    var isMounted = useIsMounted();
    useEffect(function () {
        inputsRef.current = { cb: cb, delay: delay };
    });
    return useCallback(_.debounce(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Debounce is an async callback. Cancel it, if in the meanwhile
        // (1) component has been unmounted (see isMounted in snippet)
        // (2) delay has changed
        if (inputsRef.current.delay === delay && isMounted())
            (_a = inputsRef.current).cb.apply(_a, args);
    }, delay, options), [delay, _.debounce]);
}
